document.addEventListener('DOMContentLoaded', function () {

new PerformanceObserver(function(e) {
!e.getEntriesByType("resource").some(({name})=>/\/cart\/(change|update|add|clear)/i.test(name)) || setTimeout(function() { refreshCollectionPage() }, 1000);
}).observe({entryTypes: ["resource"]});


async function updateCart(id,no,handle)
{
let updates={};
updates[id]=no;
await fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
  return response.json();
}).
then(async(res)=>{

let existing = JSON.parse(sessionStorage.getItem("productData")) || {};
existing[handle] = id;
if(no == 0)
{
delete existing[handle];
}
sessionStorage.setItem("productData", JSON.stringify(existing));
})
.catch((error) => {
  console.error('Error:', error);
});

}

async function refreshCollectionPage(){

let html = await fetch(window.location.pathname + "?sections=main-collection-product-grid").then(res => res.json());

let htmlString = html['main-collection-product-grid'];
const parser = new DOMParser();
const doc = parser.parseFromString(htmlString, 'text/html');

// Update cart count
let count = doc.querySelector(".ACC_YG_Collection_38_cart a")?.getAttribute("data-count");
if (count !== null) {
document.querySelector(".ACC_YG_Collection_38_cart a").setAttribute("data-count", count);
}

let products = doc.querySelector(".ACC_YG_Collection_38_products_inner")?.outerHTML;
if (products) {
document.querySelector(".ACC_YG_Collection_38_products_inner").outerHTML = products;

document.querySelectorAll('.ACC_YG_Collection_38_grid_product_variants').forEach(function(elm){
let handle= elm.getAttribute("data-handle");
let existing = JSON.parse(sessionStorage.getItem("productData")) || {};
if(existing)
{
let id = existing[handle];
if(id)
{
document.querySelector(`.ACC_YG_Collection_38_variant_link[data-id="${id}"]`)?.click();
}
}

})

}

}

document.addEventListener('click', async function (e) {

if (!e.target.closest('.ACC_YG_Collection_38_grid_product_variants')) {
document.querySelectorAll(".ACC_YG_Collection_38_allvariants").forEach(function(elm){
elm.classList.remove("active-variant")
})
}

const updatePlusCart = e.target.closest(".ACC_YG_Collection_38_grid_product_atc_plus");
const updateMinusCart = e.target.closest(".ACC_YG_Collection_38_grid_product_atc_minus");
if(updatePlusCart )
{
updatePlusCart.setAttribute("disabled","disabled")
updatePlusCart.querySelector(".static-svg-plus").style.display="none";
updatePlusCart.querySelector(".loading-svg-plus").style.display="flex";
}
if(updateMinusCart)
{
updateMinusCart.setAttribute("disabled","disabled")
updateMinusCart.querySelector(".static-svg-minus").style.display="none";
updateMinusCart.querySelector(".loading-svg-minus").style.display="flex";
}
if(updatePlusCart)
{
let no = updatePlusCart.previousElementSibling.textContent;
let parent = updatePlusCart.parentNode.parentNode.parentNode;
let id = parent.querySelector(".ACC_YG_Collection_38_grid_product_variants").getAttribute("data-id");
let handle = parent.querySelector(".ACC_YG_Collection_38_grid_product_variants").getAttribute("data-handle");


no = parseInt(no);
no=no+1;
await updateCart(id,no,handle)
}

if(updateMinusCart)
{
let no = updateMinusCart.nextElementSibling.textContent;
no = parseInt(no);
no=no-1;
let parent = updateMinusCart.parentNode.parentNode.parentNode;
let id = parent.querySelector(".ACC_YG_Collection_38_grid_product_variants").getAttribute("data-id");
let handle = parent.querySelector(".ACC_YG_Collection_38_grid_product_variants").getAttribute("data-handle");

await updateCart(id,no,handle)
}

const selectVariant = e.target.closest(".ACC_YG_Collection_38_variant_link");

if(selectVariant)
{
let id =  selectVariant.getAttribute("data-id");
let title =  selectVariant.getAttribute("data-title");
let cartstatus = selectVariant.getAttribute("data-added");
let cartamount = selectVariant.getAttribute("data-quantity");
let parentELM = selectVariant.parentNode.parentNode.parentNode;
parentELM.querySelector(".ACC_YG_Collection_38_cart_input").textContent=cartamount;

if(cartstatus == "true")
{

parentELM.querySelector(".ACC_YG_Collection_38_cart_added").style.display="flex";
parentELM.querySelector(".ACC_YG_Collection_38_grid_product_atc").style.display="none";
}
else 
{

parentELM.querySelector(".ACC_YG_Collection_38_cart_added").style.display="none"
parentELM.querySelector(".ACC_YG_Collection_38_grid_product_atc").style.display="flex";
}

selectVariant.parentNode.previousElementSibling.setAttribute("data-id",id);
selectVariant.parentNode.previousElementSibling.querySelector("span").textContent=title;
selectVariant.parentNode.classList.remove('active-variant')
}

const toggleBtn = e.target.closest('.ACC_YG_Collection_38_grid_product_variants');
if (toggleBtn) {
const container = toggleBtn.closest('.ACC_YG_Collection_38_grid_product_atcContainer');
if (container) {

const variantElement = container.querySelector('.ACC_YG_Collection_38_allvariants');
if (variantElement) {
variantElement.classList.toggle('active-variant');
if(variantElement.classList.contains('active-variant'))
{
let handle1 = variantElement.previousElementSibling.getAttribute("data-handle");
document.querySelectorAll(".ACC_YG_Collection_38_allvariants").forEach(function(elm){

let handle2= elm.previousElementSibling.getAttribute("data-handle");

if(handle1 != handle2)
{
elm.classList.remove('active-variant')
}
})
}
}
}
}
const elm = e.target.closest('.ACC_YG_Collection_38_variant_link');
if (!elm) return;

const price = elm.getAttribute('data-price');
const image = elm.getAttribute('data-image');
const status = elm.getAttribute('data-status');
const atc = elm.parentNode.parentNode.parentNode.querySelector(".ACC_YG_Collection_38_grid_product_atc");
if(status == "true")
{
atc.removeAttribute("disabled")
}
else 
{
atc.setAttribute("disabled","disabled")
}
const priceContainer = elm
.closest('.ACC_YG_Collection_38_grid_productContent')
?.querySelector('.ACC_YG_Collection_38_grid_product_price');

if (priceContainer && price) {
priceContainer.textContent = price;
}

if (image) {
const productContent = elm
.closest('.ACC_YG_Collection_38_grid_productContent')
?.parentNode
?.querySelector('.ACC_YG_Collection_38_grid_image a .product-image-main');

if (productContent) {
productContent.setAttribute('src', image);
productContent.removeAttribute('srcset');
}
}
});

// Handle Add to Cart clicks using event delegation
document.addEventListener('click', function (e) {
const elm = e.target.closest('.ACC_YG_Collection_38_grid_product_atc');
if (!elm) return;

e.preventDefault();

const container = elm.closest('.ACC_YG_Collection_38_grid_product_atcContainer');
const variantSelect = container.querySelector('.ACC_YG_Collection_38_grid_product_variants');
const id = variantSelect.getAttribute("data-id")
const handle = variantSelect.getAttribute("data-handle")
elm.setAttribute("disabled","disabled")
elm.querySelector("span").style.display="none";
elm.querySelector(".loading-svg-atc").style.display="flex";
const formData = {
items: [{
id: id,
quantity: 1
}]
};

fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(formData)
})
.then(response => response.json())
.then(async (res) => {
let existing = JSON.parse(sessionStorage.getItem("productData")) || {};
existing[handle] = id;

sessionStorage.setItem("productData", JSON.stringify(existing));
if (window.Boost && window.Boost.Cart) {
window.Boost.Cart.open();
}
})
.catch((error) => {
console.error('Error:', error);
});
});

});
